<!-- 由 suu 创建于 2022-05-05 星期四 -->
<template>
  <div class="ques-checkbox">
    <div class="q-title">{{ info.field_title }}<span>（多选）</span></div>
    <div class="q-list">
      <template v-for="(item, index) in info.field_unit">
        <div
          class="l-item"
          :class="{ 'l-item-ac': value.includes(item.key) }"
          @click="handelClick(item)"
          v-if="!item.is_sex || (item.is_sex && gender == '女')"
          :key="index"
        >
          {{ item.value }}
        </div>
      </template>
    </div>
    <div
      class="q-desc"
      v-if="info.sub_text && isCR(info.sub_text)"
      v-html="info.sub_text"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'ques-checkbox',

  components: {},

  props: {
    info: {},
    gender: {}
  },

  data() {
    return {
      value: [] // 选中的数据
    }
  },

  computed: {
    // 标记当前选择的是否是互斥项
    curIsSpe() {
      return (
        (this.value[0] &&
          this.info['field_unit'].find((v) => v.key === this.value[0])[
            'is_spe'
          ]) ||
        false
      )
    }
  },

  watch: {},

  created() {
    this.value = this.info.value || []
    // 判断性别是否与当前选项匹配  防止先选女生 选了女生独有选项再回去选择了男生
    this.formatGenderValue()
  },

  mounted() {},

  destroyed() {},

  methods: {
    // 潮热选项 特殊判断
    isCR(str) {
      if (str.indexOf('*潮热：') > -1 && this.gender !== '女') {
        return false
      }
      return true
    },
    // 判断性别是否与当前选项匹配  防止先选女生 选了女生独有选项再回去选择了男生
    formatGenderValue() {
      this.value.map((v, index) => {
        const item = this.info.field_unit.find((q) => q.key === v)
        if (item.is_sex && this.gender === '男') {
          // 当前为男生 但选项为女生专有时去掉该选项
          this.value.splice(index, 1)
        }
      })
    },
    // 点击选项
    handelClick(item) {
      const index = this.value.indexOf(item.key)
      const key = item.key
      if (index > -1) {
        this.value.splice(index, 1)
      }
      // 互斥选项时 只保留当前 curIsSpe 互斥标记转为true
      // 上一次选择的是互斥项时  则直接覆盖
      else if (item['is_spe'] || this.curIsSpe) {
        this.value = [key]
      } else if (!item.max || (item.max && this.value.length < item.max)) {
        // 判断是否有长度限制
        // 判断当前 已选是否是互斥 如果
        this.value.push(key)
      }
      this.$emit('on-change', this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.ques-checkbox {
  width: 100%;
  box-sizing: border-box;
  .q-title {
    margin-left: 18px;
    font-size: 24px;
    font-weight: 600;
    color: #000000;
    span {
      font-size: 13px;
      font-weight: 500;
    }
  }
  .q-list {
    width: 100%;
    box-sizing: border-box;
    margin-top: 24px;
    .l-item {
      width: 100%;
      box-sizing: border-box;
      padding: 14px 20px;
      background: #f5f6fa;
      border-radius: 12px;
      font-size: 14px;
      font-weight: 500;
      color: #262f44;
      text-align: left;
      & + .l-item {
        margin-top: 12px;
      }
    }
    .l-item-ac {
      background: #977af4;
      color: #fff;
      font-weight: 600;
    }
  }
  .q-desc {
    font-size: 11px;
    width: 100%;
    box-sizing: border-box;
    padding: 16px;
    font-weight: 500;
    color: #b77f50;
    line-height: 20px;
  }
}
</style>
